import { render, staticRenderFns } from "./QueueForm.vue?vue&type=template&id=a434e862"
import script from "./QueueForm.vue?vue&type=script&lang=js"
export * from "./QueueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports